import { Button, Modal } from "antd";
import React, { useRef } from "react";
import { useReactToPrint } from "react-to-print";
import { Images } from "../Controller";
import { useSelector } from "react-redux";

const ReportDrawer = ({ title, open, setOpen, data }) => {
  const printRef = useRef(null);
  const profiledetail = useSelector((state) => state.B2B.profileDetail);

  const handlePrint = useReactToPrint({
    content: () => printRef.current,
  });

  if (!data) return null;

  return (
    <Modal
      title={null}
      footer={null}
      open={open}
      maskClosable={false}
      closeIcon={false}
      onCancel={() => setOpen(false)}
      width="auto"
      bodyStyle={{ padding: 0 }}
      style={{
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        padding: 0,
      }}
      className="inline-block"
      transitionName="" // disable modal animation
      maskTransitionName="" // disable overlay animation
      destroyOnClose={true} // optional: destroys modal content on close to avoid re-render issues
    >
      {/* PRINT AREA */}
      <div
        ref={printRef}
        className="bg-white text-[12px] border-2 border-blue-700 p-4 inline-block"
      >
        {/* HEADER */}
        <div className="flex justify-between items-center mb-2">
          {data?.data?.["Remitter Name"] && (
            <div className="flex items-center">
              <p className="p-2 font-medium">Remitter Name :</p>
              <p className="text-xs">
                {data?.data?.["Remitter Name"]
                  ? data?.data?.["Remitter Name"]
                  : "-"}
                {data?.data?.["Remitter Mobile"] &&
                  `(${data?.data?.["Remitter Mobile"]})`}
              </p>
            </div>
          )}

          <img src={Images?.WebsiteLogo} className="h-10" alt="Logo" />
          <div>
            <div className="flex items-center">
              <p className="p-2 font-medium">Shop Name :</p>
              <p className="text-xs">{profiledetail?.business_name}</p>
            </div>
            <div className="flex items-center">
              <p className="p-2 font-medium">Mobile :</p>
              <p className="text-xs">{profiledetail?.mobile}</p>
            </div>
          </div>
        </div>

        <p className="text-center font-semibold text-lg mb-4">{title}</p>

        {/* DYNAMIC FIELDS TABLE */}
        <table className="text-sm border border-gray-300 w-auto">
          <tbody>
            {/* LABEL ROW */}
            <tr className="bg-gray-50">
              {data?.transaction_id && (
                <td className="border p-2 font-medium">Transaction ID</td>
              )}
              {Object.keys(data?.data || {}).map((title) => (
                <td key={title} className="border p-2 font-medium">
                  {title}
                </td>
              ))}
            </tr>

            {/* VALUE ROW */}
            <tr>
              {data?.transaction_id && (
                <td className="border p-2">{data.transaction_id}</td>
              )}
              {Object.entries(data?.data || {}).map(([title, value]) => (
                <td
                  key={title}
                  className={`border p-2 ${
                    title.toLowerCase() === "status"
                      ? value === "Success"
                        ? "text-green-600 font-semibold"
                        : value === "Pending"
                          ? "text-yellow-600 font-semibold"
                          : "text-red-600 font-semibold"
                      : ""
                  }`}
                >
                  {value || "-"}
                </td>
              ))}
            </tr>
          </tbody>
        </table>
      </div>

      {/* ACTIONS */}
      <div className="flex gap-2 mt-4">
        <Button className="w-full" onClick={() => setOpen(false)}>
          Close
        </Button>

        <Button className="w-full" onClick={handlePrint}>
          Print
        </Button>
      </div>
    </Modal>
  );
};

export default ReportDrawer;
